import bg from "assets/images/bg/bg-somos-coop.jpg";
import { useCallback, useEffect } from "react";
import usePointsStore from "store";

import logo from "assets/images/logo-avalia-governanca.svg";
import AchievementModal from "components/modal/AchievementModal";

export default function GovernancaGame() {
	const {
		points,
		pontosGameGovernanca,
		setPontosGameGovernanca,
		toggleNavigation,
	} = usePointsStore();

	const onMessage = useCallback(
		({ data }: any) => {
			if (data.type === "game-finished") {
				toggleNavigation(true);
				if (data.score === 10) {
					setPontosGameGovernanca(1000);
				}
			}
		},
		[toggleNavigation, points]
	);

	useEffect(() => {
		toggleNavigation(false);
		window.addEventListener("message", onMessage);
		return () => {
			window.removeEventListener("message", onMessage);
			toggleNavigation(true);
		};
	}, [toggleNavigation]);

	return (
		<>
			{pontosGameGovernanca ? (
				<AchievementModal
					positive
					points={pontosGameGovernanca}
					logo={logo}
					title={`Você conseguiu desviar de todos os obstáculos!`}
				/>
			) : null}
			<div
				className="bg-black absolute top-0 left-0 w-full h-full"
				style={{
					backgroundImage: `url(${bg})`,
				}}
			>
				<div className="absolute flex flex-col p-5 gap-5 w-full h-full top-0 left-0 z-10 bg-blue-dark bg-opacity-90">
					<div className="mt-[100px] text-2xl text-white flex flex-col items-center">
						<div className="flex gap-10 items-center">
							<div className="text-center leading-tight">
								Arraste o dedo para os lados
								<br />e desvie dos obstáculos e chegue até o final
							</div>
						</div>
					</div>
					<div className="relative flex-1 bg-black rounded-xl overflow-hidden">
						<iframe
							src="/games/v3/index.html?game=governanca"
							className="absolute w-full h-full"
						/>
					</div>
				</div>
			</div>
		</>
	);
}
